import { render, staticRenderFns } from "./CPDueDiligenceDocumentRequirements.vue?vue&type=template&id=3631e08c&scoped=true&"
import script from "./CPDueDiligenceDocumentRequirements.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceDocumentRequirements.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligenceDocumentRequirements.vue?vue&type=style&index=0&id=3631e08c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631e08c",
  null
  
)

export default component.exports